import '@/plugins/passiveEvents';
import 'font-awesome/css/font-awesome.css';
import Vue from "vue";
import "@/mixins/money";
import '@/plugins/vuetify';
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import "@/components/monaco/PermissionUtils";
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fontsource/roboto/100.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/900.css';
import '@fontsource/cairo/400.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import 'material-icons/iconfont/material-icons.css';
import "mapbox-gl/dist/mapbox-gl.css";
import axios from 'axios';
import api from '@/constants/api';
import moment from 'moment';
import titleMixin from '@/mixins/titleMixin';
import * as VueGoogleMaps from 'vue2-google-maps';
import Dialova from '@/plugins/dialova.js';
import './registerServiceWorker';
import formatDateMixin from "@/mixins/formatDate";

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyAvWQlGwdRe7kdMxM9uHuEjjSkYxD1YmWs',
        libraries: 'places',
    },
});

Vue.use(Dialova);
Vue.config.productionTip = false;
axios.defaults.timeout = 1000 * 300;
axios.defaults.baseURL = api.MAIN_URL + '/api/transfer-center/';

// Global 401 handler: an expired/invalid token logs the user out and bounces
// them to the login screen instead of leaving them on a broken page.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit('LOGOUT');
      if (router.currentRoute.name !== 'Login') {
        router.push({ name: 'Login' }).catch(() => {});
      }
    }
    return Promise.reject(error);
  }
);

Vue.prototype.axios = axios;
Vue.prototype.api = api;
Vue.prototype.moment = moment;
window.moment = moment;
Vue.mixin(titleMixin);
Vue.mixin(formatDateMixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
